import { Slider } from '@material-ui/core';
import { formatMoneyAmount, getMoneySymbolByCurrency } from '@nemuru-eng/js-api-client';
import { ChangeEvent } from 'react';

import { EditDownPaymentProps } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/components/EditDownPayment';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { CustomTextField } from '@/components/shared/components/NewContextForms/shared/CustomTextField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { Text } from '@/components/shared/components/Text';

export const EditDownPaymentForm = ({
  checkoutSession,
  newDownPaymentValue,
  setNewDownPaymentValue,
}: Omit<EditDownPaymentProps, 'onComplete' | 'onCancel'>) => {
  const handleSliderOnChange = (_: ChangeEvent<unknown>, value: number | number[]) => {
    setNewDownPaymentValue(value as number);
  };

  const handleInputOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(event.target.value);
    if (newValue < minRange) {
      setNewDownPaymentValue(minRange);
      return;
    }
    if (newValue > maxRange) {
      setNewDownPaymentValue(maxRange);
      return;
    }
    setNewDownPaymentValue(event.target.value ? parseFloat(event.target.value) : 0);
  };

  const minRange = 0;
  const maxRange = checkoutSession.cart.totalPriceWithTax.amount - 0.01; // TODO: limit?

  return (
    <CustomPaper fill="grey.dark">
      <FlexColumn gridGap={30} width={'100%'} alignItems={'flex-end'}>
        <Slider
          color="secondary"
          min={minRange}
          max={maxRange}
          value={newDownPaymentValue as number}
          onChange={handleSliderOnChange}
          style={{
            marginTop: '10px',
            marginBottom: '14px',
          }}
        />
        <FlexRow justifyContent={'space-between'} alignItems={'flex-start'} width={'100%'}>
          <FlexColumn gridGap={8} alignItems={'flex-start'}>
            <Font color="textPrimary" variant="body2">
              <strong>
                <Text tId={'TOTAL_TO_FINANCE'} />
              </strong>
              <br />
            </Font>
            <Font color="textPrimary" variant="body2">
              {formatMoneyAmount({
                amount: checkoutSession.totalPrice.amount - newDownPaymentValue,
                currency: checkoutSession.totalPrice.currency,
              })}
            </Font>
          </FlexColumn>
          <FlexColumn gridGap={16} maxWidth={'130px'} alignItems={'flex-end'}>
            <Font color="textPrimary" variant="body2">
              <strong>
                <Text tId={'DOWN_PAYMENT'} />
              </strong>
            </Font>
            <CustomTextField
              style={{
                textAlign: 'right',
                marginTop: '-14px',
              }}
              autoFocus
              type="number"
              value={newDownPaymentValue}
              InputProps={{
                endAdornment: (
                  <Font variant="body2" color="textPrimary" style={{ marginBottom: '10px' }}>
                    <strong>{getMoneySymbolByCurrency(checkoutSession.downPayment?.amount.currency)}</strong>
                  </Font>
                ),
                style: {
                  paddingRight: '20px',
                },
              }}
              fieldVariant={FieldVariant.form}
              onChange={handleInputOnChange}
            />
          </FlexColumn>
        </FlexRow>
      </FlexColumn>
    </CustomPaper>
  );
};
